import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsImdbComponent } from './simple-icons-imdb.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsImdbComponent ],
    exports:      [ SimpleIconsImdbComponent ],
    bootstrap:    []
})
export class SimpleIconsImdbModule {}
